<section class="header">
    <div class="container">
        <div class="row">
            <div class="col-sm-4">
                <a [routerLink]="['/home']"><img alt="logo" class="brand-logo" src="./assets/img/logo.jpg"></a>
            </div>
            <div class="col-sm-8 text-right">
                <span *ngIf="envName && envName.toUpperCase().trim()!=='PROD'"class="envName">{{envName}}</span>
                <div class="nav-menu" *ngIf="userInfo?.isCAPStaff">
                    <span>{{userInfo?.firstName}}</span>
                    <span><a href="{{logOutURL}}">Logout</a></span>
                </div>
            </div>
        </div>
    </div>
</section>